import React, {useState} from "react";

export default function CompatibilityCard(props) {
    const {game: gamedata, setSelectedGame} = props;
    const [imageSrc, setImageSrc] = useState(gamedata.capsule);
    
    return (
        <article id={gamedata.key}>
            <span className="image">
                <img src={imageSrc} alt={gamedata.name} style={{width:'420px', height:'230px'}}/>
                <img className="overlay" src={gamedata.compatible === 1 ? "images/overlays/NotCompatible.png" : gamedata.compatible === 2 || gamedata.compatible === 3 ? "images/overlays/HasKnownIssues.png" : "images/overlays/NoKnownIssues.png" } alt={gamedata.compatible === 1 ? "Not Compatible" : gamedata.compatible === 2 || gamedata.compatible === 3 ? "Known Workaround" : "Compatible" }/>
                <img className="overlay" src={gamedata.storeSource === 0 ? "images/overlays/Steam.png" : "images/overlays/Oculus.png"} alt={gamedata.storeSource === 0 ? "Steam Game" : "Oculus Game"}/>
            </span>
            <a href="#" onClick={() => setSelectedGame()}/>
        </article>
    )
}